import React from 'react'
import { Redirect } from 'react-router-dom'
import { SEO } from '../../../components/Seo/seo'
import { useIntl } from 'react-intl'
import Layout from '../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../routes'
import { subscriptionsReport } from '../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../AuthenticatedUserContext'
import { FormLoader } from '../../../components/Loader/FormLoader'
import SubscriptionsReportContent from '../../../components/Dashboard/Subscription/SubscriptionsReportContent'
import { LanguageConsumer } from '../../../LanguageContext'


const SubscriptionsReport = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'PageTitle.SubscriptionsReport' })}
           pathname={window.location.origin}
           titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
           image={subscriptionsReport.image}
           description={intl.formatMessage({ id: 'PageTitle.SubscriptionsReport' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, handleNotificationCall }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true}/>}
            {!!Object.keys(userData).length &&
            <>
              {!!userData.is_admin ?
                <Layout content={<LanguageConsumer>
                  {({ locale }) => (
                    <SubscriptionsReportContent handleNotificationCall={handleNotificationCall} locale={locale}/>
                  )}
                </LanguageConsumer>}/> :
                (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
              }
            </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default SubscriptionsReport

